import React from 'react';
import styled from 'styled-components';

import DnaBackground from './DnaBackground';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import Seo from './Seo';
import LegalPageLayout, { Section, SectionTitle } from './LegalPageLayout';

const PageShell = styled.div`
  min-height: 100vh;
  padding: 2.5rem 1.25rem 3rem;
  position: relative;
  z-index: 1;
`;

const ShellContainer = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
`;

/**
 * Shared shell for legal/static pages — matches quiz header spacing (2.5rem top).
 */
const LegalDocumentPage = ({
  title,
  description,
  path,
  lastUpdated,
  children,
}) => (
  <>
    <Seo title={title} description={description} path={path} />
    <DnaBackground fullWidth />
    <PageShell>
      <ShellContainer>
        <SiteHeader />
        <LegalPageLayout title={title} lastUpdated={lastUpdated}>
          {children}
        </LegalPageLayout>
        <SiteFooter />
      </ShellContainer>
    </PageShell>
  </>
);

export { Section, SectionTitle };
export default LegalDocumentPage;
